import { alpha, Theme } from '@mui/material';

export default {
    resultItems: {
        gap: '4px',
    },
    item: {
        border: '1px solid',
        borderColor: (theme: Theme) => theme.palette.divider,
        borderRadius: '3px',
        padding: '6px 8px 8px 8px',
        gap: '4px',
    },
    link: {
        fontSize: '12px',
        cursor: 'pointer',
        color: (theme: Theme) => theme.palette.primary.main,
        textDecoration: 'underline',
    },
    description: {
        paddingLeft: '24px',
        '& p': {
            marginBlockStart: '0',
            marginBlockEnd: '0',
        },
    },
};
